import React from "react";
import { Link } from "react-router-dom";
import { BsCartCheck } from "react-icons/bs";
import { FiShoppingBag } from "react-icons/fi";
import { AiOutlineFundView } from "react-icons/ai";
import { SlPeople } from "react-icons/sl";
import { useTranslation } from "react-i18next";

const DashboardSummaryCards = ({
  orderCount,
  earnings,
  dashboardData,
  newDbImg,
}) => {
  const { t } = useTranslation();

  return (
    <div className="p-4 dashboard-box border border-gray-200 bg-white shadow-sm md:col-span-2">
      <p className="text-gray-500 text-sm pl-6 text-center">
        {t("v_dash_row1_title")}
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 h-full">
        <div className="justify-center items-center flex">
          <img src={newDbImg} className="w-64" alt="dashboard visual" />
        </div>

        <div className="reports pb-10 md:p-5 grid grid-cols-2 gap-4 h-full">
          <SummaryCard
            to="/vendor/orders"
            icon={<BsCartCheck size={30} className="text-white" />}
            count={orderCount || 0}
            label={t("v_dash_row1_totalOr")}
          />

          <SummaryCard
            to="/vendor/products"
            icon={<FiShoppingBag size={30} className="text-white" />}
            count={dashboardData?.products?.count || 0}
            label={t("v_dash_row1_totalPro")}
          />

          <SummaryCard
            to="/vendor/payouts"
            icon={<AiOutlineFundView size={30} className="text-white" />}
            count={earnings?.toFixed(2) || 0}
            label={t("v_dash_row1_totalEarn")}
          />

          <SummaryCard
            to="/vendor/customers"
            icon={<SlPeople size={30} className="text-white" />}
            count={dashboardData?.customers?.count || 0}
            label={t("v_dash_row1_totalCust")}
          />
        </div>
      </div>
    </div>
  );
};

const SummaryCard = ({ to, icon, count, label }) => (
  <Link
    to={to}
    className="report-icons flex items-center justify-start gap-x-2 roboto font-medium"
  >
    <div className="p-2 bg-primary rounded-full border border-primary">
      {icon}
    </div>
    <p className="text-xs">
      {count} <br />
      {label}
    </p>
  </Link>
);

export default DashboardSummaryCards;
